<template>
    <div :class="{ 'menu-open' : isSidebarOpen }">
        <Header></Header>
        <div class="dashboard d-flex">
            <LeftSide></LeftSide>
            <div class="dashboard-right">
                <child/>

            </div>
        </div>



    </div>

</template>

<script>
    import Header from '~/components/admin/Header'
    import LeftSide from '~/components/admin/LeftSide'

    export default {
        name: 'MainLayout',

        components: {
            Header,
            LeftSide
        },

        data() {
            return {
                isActive: false
            }
        },

        computed: {
            isSidebarOpen(){
                return this.$store.getters['layout/isSidebarOpen'];
            }
        },

        methods: {
            makeAPayment() {
                swal({
                    type: 'warning',
                    title: 'In progress',
                    text: 'This feature is unavailable !',
                    reverseButtons: true,
                    // confirmButtonText: 'Close',
                })
            },

            tickets() {
                this.$router.push({ name: 'tickets'});
            },

            call_number() {
                this.$router.push({ name: 'call'});
            },

            trigger_talk: function() {
                this.isActive = !this.isActive;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/layouts/admin.vue